import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgTwitterOutlined = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "M7.403 15.378c5.283 0 8.172-4.377 8.172-8.172q0-.187-.008-.372A5.8 5.8 0 0 0 17 5.347a5.7 5.7 0 0 1-1.65.452 2.88 2.88 0 0 0 1.263-1.589 5.8 5.8 0 0 1-1.823.697 2.873 2.873 0 0 0-4.895 2.62 8.15 8.15 0 0 1-5.92-3 2.87 2.87 0 0 0 .89 3.835A2.85 2.85 0 0 1 3.562 8v.036c0 1.391.99 2.553 2.303 2.816a2.9 2.9 0 0 1-1.297.05 2.88 2.88 0 0 0 2.684 1.994A5.76 5.76 0 0 1 3 14.088a8.13 8.13 0 0 0 4.403 1.29"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitterOutlined);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
